<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <!-- Dashboard -->
      <li class="nav-item">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="dashboard"
          navText="Dashboard"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- 학생(아동) 종합정보 - role이 1인 경우에만 표시 -->
      <li class="nav-item" v-if="userRole === '1'">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="studentsummary"
          navText="학생(아동) 종합정보"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- 학생(아동)리스트 -->
      <li class="nav-item">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="memberlist"
          navText="학생(아동)리스트"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- 학생(아동)기록부 - role이 4가 아닐 때만 표시 -->
      <li class="nav-item" v-if="userRole !== '4'">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="memberbook"
          navText="학생(아동)기록부"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>
      
      <!-- 출석 현황 -->
      <li class="nav-item">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="attendlist"
          navText="출석현황"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- 선생님 목록 - role이 4가 아닐 때만 표시 -->
      <li class="nav-item" v-if="userRole !== '4'">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="teacherlist"
          navText="선생님 리스트"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>     
      <!-- 반 관리 -->
      <li class="nav-item" v-if="userRole !== '4'">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="classmanage"
          navText="반/교사 관리"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>
      <!--  출석통계  -->
      <li class="nav-item">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="attendgrid"
          navText="출석날짜그리드"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>    
      <!--  주차별통계  -->
      <li class="nav-item">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="attendweekly"
          navText="주차별출석통계"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>  
      <!-- 자료  -->
      <li class="nav-item">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="filelist"
          navText="파일 다운로드"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>    


      <!-- (임시) 선생님 자료 이관 -->
      <li class="nav-item" v-if="true">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="teachertemp"
          navText="(26년) 선생님 반 편성"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- (26년) 아동(학생) 정보 변경 -->
      <li class="nav-item" v-if="true">
        <sidenav-collapse
          url="#"
          :aria-controls="''"
          v-bind:collapse="false"
          collapseRef="studenttemp"
          navText="(26년) 아동(학생) 반 편성"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>

      
      <li class="nav-item">
        <a
          class="nav-link text-primary"
          href="#"
          @click.prevent="logout"
        >
          <i class="material-icons-round opacity-10 fs-5"></i>
          <span class="nav-link-text ms-1">로그아웃</span>
        </a>
      </li>
    </ul>
    <div class="sidenav-footer position-absolute w-100 bottom-0">
      <div class="mx-3">
      </div>
    </div>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active",
    };
  },
  components: {
    SidenavCollapse,
  },
  computed: {
    ...mapState(["isRTL", "isAbsolute"]),
    currentRouteName() {
      return this.$route.name;
    },
    userRole() {
      console.log("userRole:", this.$store.state.userData);
      return this.$store.state.userData?.role || '';
    }
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    toggleSidebar() {
      this.navbarMinimize();
    },
    logout() {
      this.$store.dispatch('logout')
      this.$router.push('/sign-in')
    }
  }
};
</script>
